import { GAME_ID, REDUX_ACTIONS } from 'a/sortItOut/data/constants';
import { retrieveOnboardingCategories, retrieveOnboardingQueue } from '../../content/curriculum';

export const initialState = {
  categories: [],
  highlightedCategory: null,
  interactionLocked: false,
  queue: [],
  currentQueueItem: {
    word: null,
  },
  sortedItems: {
    hard: [],
    soft: [],
  },
  highlightedArrow: null,
};
let currentQueueItem = {
  word: null,
};
let queue = [];
let category = null;
const onboardingReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }
  switch (action.type) {
    default:
      return state;
    case REDUX_ACTIONS.INIT_ONBOARDING: {
      const categories = retrieveOnboardingCategories();
      return {
        ...initialState,
        categories,
        queue: retrieveOnboardingQueue(),
        sortedItems: {
          [categories[0].split(' ')[0]]: [],
          [categories[1].split(' ')[0]]: [],
        },
      };
    }
    case REDUX_ACTIONS.SET_HIGHLIGHTED_ONBOARDING_CATEGORY:
      return {
        ...state,
        highlightedCategory: action.payload.highlightedCategory,
      };
    case REDUX_ACTIONS.NEXT_ONBOARDING_ITEM:
      queue = state.queue.slice();
      currentQueueItem = queue.shift() || { word: null };

      return {
        ...state,
        currentQueueItem,
        queue,
      };
    case REDUX_ACTIONS.MOVE_TO_ONBOARDIBNG_CATEGORY:
      currentQueueItem = state.currentQueueItem;
      category = action.payload.category;

      return {
        ...state,
        sortedItems: {
          ...state.sortedItems,
          [category.split(' ')[0]]: [...state.sortedItems[category.split(' ')[0]], currentQueueItem],
        },
      };
    case REDUX_ACTIONS.SET_HIGHLIGHTED_ONBOARDING_ARROW:
      return {
        ...state,
        highlightedArrow: action.payload.highlightedArrow,
      };
    case REDUX_ACTIONS.SET_ONBOARDING_INTERACTION_LOCKED:
      return {
        ...state,
        interactionLocked: action.payload.interactionLocked,
      };
  }
};

export default onboardingReducer;
